// extracted by mini-css-extract-plugin
module.exports = {"container":"Zx","productName":"_x","modal":"ay","dimensions":"by","recipientEmail":"cy","lowStock":"dy","recommendedFit":"ey","notRecommendedFit":"fy"};